// src/components/MaintenancePage.jsx
// Pillar B3 — shown to non-admin users when maintenance mode is enabled.
import { Wrench } from 'lucide-react'

import { T } from '../theme/theme'
export function MaintenancePage({ message }) {
  const fallback = "KaiLux is temporarily undergoing maintenance. We'll be back shortly."
  return (
    <div style={{ minHeight:'100vh', background:T.bg, display:'flex',
      flexDirection:'column', alignItems:'center', justifyContent:'center',
      textAlign:'center', padding:'0 16px', fontFamily:"'Outfit',sans-serif",
      color:T.tx }}>
      <div style={{ width:'64px', height:'64px', background:T.ord,
        borderRadius:'16px', display:'flex', alignItems:'center', justifyContent:'center',
        marginBottom:'24px' }}><Wrench size={26} strokeWidth={1.5} color={T.or}/></div>
      <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:'24px', fontWeight:'800' }}>
        We'll be right back
      </h1>
      <p style={{ color:T.lt, marginTop:'12px', maxWidth:'420px', fontSize:'14px', lineHeight:'1.6' }}>
        {message || fallback}
      </p>
      <p style={{ fontSize:'12px', color:T.mt, marginTop:'24px' }}>
        Need urgent support? Email{' '}
        <a href="mailto:support@kailux.co.za" style={{ color:T.or, textDecoration:'underline' }}>
          support@kailux.co.za
        </a>
      </p>
    </div>
  )
}
